<template>
    <ul>
        <li
            v-for="search in savedSearches"
            :key="search.saved_search_id"
        >
            <a :href="search.redirect_url">
                {{ search.label }}
            </a>
        </li>
    </ul>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'SavedSearches',

        data() {
            return {
                savedSearches: [],
            };
        },

        created() {
            this.getSavedSearches();
        },

        methods: {
            ...mapActions('me', {
                $_getSavedSearches: 'getSavedSearches',
            }),

            getSavedSearches() {
                this.$_getSavedSearches().then((response) => {
                    this.savedSearches = response.data;
                });
            },
        },
    };
</script>
